import { IonContent, IonIcon, IonLabel, IonPage, IonSegmentButton, IonSlide, IonSlides } from '@ionic/react';
import { documentOutline, folderOutline, giftOutline } from 'ionicons/icons';
import { useEffect, useRef, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router';
import LoadingContainer from '../../components/loading/LoadingContainer';

import Segment from '../../components/segments/Segment';
import LayoutGap from '../../layouts/LayoutGap';
import Toolbar from '../../layouts/Toolbar';
import { CampaignTreeDocAction } from '../../redux/actions/Campaign';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import GiftDocs from './tree-documents/GiftDoc';
import NewDoc from './tree-documents/NewDoc';
import OldDocs from './tree-documents/OldDocs';

import './TreeDocuments.css';

interface Props extends RouteComponentProps<{
    campaign_id: string
}> { }

const TreeDocuments: React.FC<Props> = ({ match }, props) => {
    const history = useHistory();
    const dispatch = useAppDispatch()

    const slideValues = ["online", "offline", "gift"]
    const [defaultSlide, setDefaultSlide] = useState("online");
    const sliderRef = useRef<HTMLIonSlidesElement>(null);

    const { loading, documents } = useAppSelector(state => state.campaignTreeDocuments);

    const [seedlings, setSeedlings] = useState(null as any);
    const [docs, setDocs] = useState(null as any);
    const [gifts, setGifts] = useState(null as any);
    const [donations, setDonations] = useState(null as any);
    const [templates, setTemplates] = useState(null as any);

    useEffect(() => {
        dispatch(CampaignTreeDocAction(match.params.campaign_id))
    }, [dispatch])

    useEffect(() => {
        setDocs(documents?.docs);
        setDonations(documents?.donations);
        setGifts(documents?.gifts)
        setTemplates(documents?.templates)
        setSeedlings(documents?.seedlings);
    }, [loading])

    const segmentClickHandler = (value: any) => {
        setDefaultSlide(value)

        let index = slideValues.findIndex((item) => {
            return item == value
        })

        sliderRef.current?.slideTo(index);
    }

    const slideChangeHandler = async () => {
        var index = await sliderRef.current?.getActiveIndex()
        setDefaultSlide(slideValues[index as number])
    }

    const changeDocsHandler = (docs: any, seedlings: any) => {
        if (seedlings != null)
            setSeedlings(seedlings);
        setDocs(docs);
    }

    const View = <LoadingContainer loading={loading}>
        <IonPage className="monthly-payment">
            <Toolbar title={"سند درخت"} hasBackButton></Toolbar>

            <LayoutGap />

            <IonContent className="main-content">
                <Segment defaultSlide={defaultSlide} change={(e: any) => segmentClickHandler(e.detail.value)}>
                    <IonSegmentButton layout="icon-start" value="online">
                        <IonIcon icon={documentOutline} size="small" />
                        <IonLabel>سند جدید</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton layout="icon-start" value="offline">
                        <IonIcon icon={folderOutline} size="small" />
                        <IonLabel>سندهای قبلی</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton layout="icon-start" value="gift">
                        <IonIcon icon={giftOutline} size="small" />
                        <IonLabel>سند هدیه</IonLabel>
                    </IonSegmentButton>
                </Segment>

                <IonSlides ref={sliderRef} onIonSlideDidChange={slideChangeHandler}>
                    <IonSlide>
                        <NewDoc project={history.location.state as any} templates={templates} docs={docs} seedlings={seedlings} donations={donations} changeDocs={changeDocsHandler} />
                    </IonSlide>
                    <IonSlide>
                        <OldDocs project={history.location.state as any} templates={templates} docs={docs} seedlings={seedlings} changeDocs={changeDocsHandler} />
                    </IonSlide>
                    <IonSlide>
                        <GiftDocs docs={gifts} />
                    </IonSlide>
                </IonSlides>
            </IonContent>
        </IonPage>
    </LoadingContainer>;

    return View
}

export default TreeDocuments